export function redAlert(msg) {
  console.error(`RED ALERT: ${msg}`);
}
